/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Created by richardwilliams on 4/13/15.
 */
'use strict';
angular.module('prism-ui.components.navigation').controller('BreadcrumbController',
	function ($location, $route, BreadcrumbService, PackageUtilService, NotificationService) {

		var self = this;

		self.breadcrumbs = BreadcrumbService.getBreadcrumbs();

		function setBreadcrumbsFromCurrentRoute() {
			if ($route.current.rootRoute) {
				var parentRoute = $route.routes[$route.current.rootRoute];
				var rootBreadcrumb = {location: parentRoute.originalPath, name: parentRoute.label, params: {}};
				self.breadcrumbs.push(rootBreadcrumb);
			}
		}

		self.navigateToBreadCrumb = function (breadcrumb) {
			if (!BreadcrumbService.editService || !BreadcrumbService.editService.editorForm ||
				(BreadcrumbService.editService.editorForm && BreadcrumbService.editService.editorForm.$pristine)) {
				if(BreadcrumbService.editService && BreadcrumbService.editService.postCloseUpdate) {
					BreadcrumbService.editService.postCloseUpdate();
				}

				if ($route.current.rootRoute === breadcrumb.location) {
					BreadcrumbService.clearBreadcrumbs();
				} else {
					self.breadcrumbs = BreadcrumbService.removeBreadcrumbs();
				}

				if (self.paramMap) {
					for (var param in self.paramMap) {
						var re = new RegExp(':' + param);
						breadcrumb.location = breadcrumb.location.replace(re, self.paramMap[param]);
					}
				}

				$location.path(breadcrumb.location);
				if (breadcrumb.params) {
					$location.search(breadcrumb.params);
				}
			} else {
				var message = 'You have unsaved changes.  Please save or revert.';
				NotificationService.createWarningNotification(message, '');
			}
		};

		if (!self.breadcrumbs.length) {
			setBreadcrumbsFromCurrentRoute();
		}
	});
